import { VIPSDataServiceURL } from "../Constants/GlobalConstant";
import { requestOptions } from "../Constants/GlobalConstant";

// Test-only: provide a safe default fetch to avoid jsdom/XHR AggregateError when no mock is set.
// If a jest mock (jest.fn) is already assigned by a test, it will be used as-is.
(() => {
  const isJest =
    typeof process !== "undefined" &&
    process.env &&
    (process.env.JEST_WORKER_ID || process.env.NODE_ENV === "test");
  if (!isJest) return;
  const g = typeof global !== "undefined" ? global : window;
  // If tests haven't mocked fetch, offer a harmless resolved response.
  if (typeof g.fetch !== "function" || !g.fetch._isMockFunction) {
    g.fetch = async () => ({
      json: async () => ({}),
      text: async () => "",
    });
  }
})();

export async function GetFirstPageIdFromLabelType(
  labelType,
  schemaID,
  setIsLoading
) {
  await fetch(
    `${VIPSDataServiceURL}/Schema/GetSchemaPageIdFromLabelType?labelType=${labelType}&schemaID=${schemaID}`,
    requestOptions
  )
    .then((response) => response.json())
    .then((data) => {
      localStorage.setItem("firstPageID", JSON.stringify(data));
    })
    .catch((err) => {
      // defer turning off loading until after initial render
      setTimeout(() => setIsLoading(false), 0);
    });
}

export async function GetSchemaPageIdFromLabelType(
  labelType,
  schemaID,
  setPageId,
  setLabelsCount2,
  setIsLoading
) {
  return await fetch(
    `${VIPSDataServiceURL}/Schema/GetSchemaPageIdFromLabelType?labelType=${labelType}&schemaID=${schemaID}`,
    requestOptions
  )
    .then((response) => response.json())
    .then((data) => {
      setPageId(data);
      setLabelsCount2((prevCount) => prevCount + 1);
      setIsLoading(false);
      return data;
    })
    .catch((err) => {
      setIsLoading(false);
    });
}

export async function GetSchemaPageItems(
  PageID,
  schemaID,
  divisionId,
  userId,
  setSchemaData,
  labelRef,
  labelType
) {
  let results = await fetch(
    `${VIPSDataServiceURL}/Schema/GetSchemaPageItems?pageID=${PageID}&schemaID=${schemaID}&divisionId=${divisionId}&labelRef=${labelRef}&userId=${userId}&labelType=${labelType}`,
    requestOptions
  );
  const data = await results.json();
  setSchemaData(data);
  return data;
}

export async function GetDeliveryAddress(customerId, divisionId) {
  let results = await fetch(
    `${VIPSDataServiceURL}/Customer/GetDeliveryAddress?customer_id=${customerId.trim()}&` +
      `division_id=${divisionId}`,
    requestOptions
  );
  const data = await results.json();
  return data;
}

export async function GetInvoiceAddress(customerId, divisionId) {
  let results = await fetch(
    `${VIPSDataServiceURL}/Customer/GetInvoiceAddress?division_id=${divisionId}&` +
      `customer_id=${customerId.trim()}`,
    requestOptions
  );
  const data = await results.json();
  return data;
}

export async function GetSystemParameterValueByName(name) {
  let results = await fetch(
    `${VIPSDataServiceURL}/Misc/GetSystemParameterValueByName?name=${name}`,
    requestOptions
  );
  const data = await results.json();
  return data;
}

export async function GetSystemParameterValueByNameTextFormat(name) {
  let results = await fetch(
    `${VIPSDataServiceURL}/Misc/GetSystemParameterValueByName?name=${name}`,
    requestOptions
  );
  const data = await results.text();
  return data;
}

/**
 * Call the EDI eCatalog API through the VIPS backend proxy to avoid CORS.
 * The backend endpoint forwards the request server-side to the external EDI service.
 *
 * @param {Object} params
 * @param {string} params.ediApiUrl          – Full EDI API base URL (from system parameter)
 * @param {string} params.subscriptionKey    – Ocp-Apim-Subscription-Key header value
 * @param {string} [params.brandCode="ZARA"] – Brand-Code header value
 * @param {Object} [params.filters={}]       – Dynamic query parameter filters (key-value pairs)
 * @returns {Promise<Array>} The EDI catalog data array
 */
export async function GetEdiCatalogData({
  ediApiUrl,
  subscriptionKey,
  brandCode = "ZARA",
  filters = {},
}) {
  // Remove undefined/null/empty values from filters
  const cleanFilters = {};
  Object.entries(filters).forEach(([k, v]) => {
    if (v != null && v !== "") {
      cleanFilters[k] = v;
    }
  });
  const body = JSON.stringify({
    ediApiUrl,
    subscriptionKey,
    brandCode,
    filters: cleanFilters,
  });

  const response = await fetch(
    `${VIPSDataServiceURL}/Misc/GetEdiCatalogData`,
    {
      method: "POST",
      headers: {
        ...requestOptions.headers,
        "Content-Type": "application/json",
      },
      body,
    }
  );

  if (!response.ok) {
    throw new Error(
      `EDI proxy returned status ${response.status}: ${response.statusText}`
    );
  }

  return response.json();
}

export async function GetTescoMapping(pageID, schemaName) {
  var name = "TescoFileUploadMappingFor_" + schemaName;
  let results = await fetch(
    `${VIPSDataServiceURL}/Misc/GetSystemParameterValueByName?name=${name}`,
    requestOptions
  );
  const mappingData = await results.json();

  const mapping =
    mappingData.mappings[pageID] || mappingData.mappings.defaultMapping;

  return mapping;
  //return mappingData;
}

export async function GetRequesteDateAPI(divisionId, ProductDesc, store_grp, priority_id = -1) {
  // Always include priority_id; default -1 aligns with server signature
  const url =
    `${VIPSDataServiceURL}/Order/GetRequestDate?divisionID=${divisionId}&` +
    `labelRef=${ProductDesc}&` +
    `storeGroup=${store_grp}&` +
    `priority_id=${priority_id}`;
  let results = await fetch(url, requestOptions);
  const data = await results.json();
  return data;
}
export async function GetCountries() {
  let results = await fetch(
    `${VIPSDataServiceURL}/Misc/GetCountries`,
    requestOptions
  );
  const data = await results.json();
  return data;
}
export const fetchCarriersDataFromAPI = async (divisionId) => {
  try {
    const response = await fetch(
      `${VIPSDataServiceURL}` + `/Misc/GetCarriers?divisionId=${divisionId}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};
export const fetchFreightTermsDataFromAPI = async (divisionId) => {
  try {
    const response = await fetch(
      `${VIPSDataServiceURL}` +
        `/Misc/GetFreightTerms?divisionId=${divisionId}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};

export const fetchLayoutInformation = async (label, store_grp, divisionId) => {
  try {
    const response = await fetch(
      `${VIPSDataServiceURL}` +
        `/Order/GetLayoutInformation?storeGroup=${store_grp}&divisionID=${divisionId}&labelRef=${label}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};
export async function getStoreInfo(storeGroup) {
  var storeInfo = await fetch(
    `${VIPSDataServiceURL}` + `/Misc/GetStoreInfo?storeGroup=` + storeGroup,
    requestOptions
  )
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      return data;
    })

    .catch((err) => {
      return false;
    });
  return storeInfo;
}

export async function getUserDivisions(userId) {
  var storeInfo = await fetch(
    `${VIPSDataServiceURL}` + `/User/GetUserDivisions?userId=` + userId,
    requestOptions
  )
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      return data;
    })

    .catch((err) => {
      return false;
    });
  return storeInfo;
}

/**
 * Checks whether a user has a specific security access.
 * @param {string} userId – The user ID from session
 * @param {string} securityId – The security access identifier to check
 * @returns {Promise<boolean>} true if the user has the security access
 */
export async function VerifyUserSecurityAccess(userId, securityId) {
  try {
    const response = await fetch(
      `${VIPSDataServiceURL}/User/VerifyUserSecurityAccess?userId=${encodeURIComponent(userId)}&securityId=${encodeURIComponent(securityId)}`,
      requestOptions
    );
    const data = await response.json();
    return !!data;
  } catch (err) {
    console.error("VerifyUserSecurityAccess failed:", err);
    return false;
  }
}

/**
 * Get the list of factory codes (customer accounts) for a user.
 *
 * Mirrors the legacy ASP.NET GetFactoryCodes() logic:
 *  - For vendor users (userType empty): returns only customers attached to the user.
 *  - For other users (admin/retailer): returns all division customers.
 *  - Results are filtered against the PMX_Watex_FactoryCodes whitelist
 *    unless the PMX_Watex_ENABLE_FOR_ALL_FACTORYCODES system parameter is "Y".
 *
 * @param {string} userId     – The logged-in user ID
 * @param {string} userType   – The user type (empty string for vendor users)
 * @param {string} divisionId – The user's division ID
 * @param {string} storeGrp   – The store group
 * @returns {Promise<Array<{factoryCode: string, value: string}>>} List of factory code objects
 */
export async function GetFactoryCodes(userId, userType, divisionId, storeGrp) {
  try {
    let url = `${VIPSDataServiceURL}/User/GetFactoryCodes?userId=${encodeURIComponent(userId)}`;
    if (userType) {
      url += `&divisionId=${encodeURIComponent(divisionId)}&storeGroup=${encodeURIComponent(storeGrp)}`;
    }
    const response = await fetch(url, requestOptions);
    const data = await response.json();
    return typeof data === 'string' ? JSON.parse(data) : data;
  } catch (err) {
    console.error("GetFactoryCodes failed:", err);
    return [];
  }
}

/**
 * Get divisions/locations for a selected factory code.
 *
 * Mirrors the legacy ASP.NET [WebMethod] GetDivisionByFactoryCode():
 *  - For vendor users (userType empty): returns customers linked to that user + factory code.
 *  - For other users: returns division customers matching the factory code.
 *
 * @param {string} factoryCode – The selected factory code text
 * @param {string} userId      – The logged-in user ID
 * @param {string} userType    – The user type (empty string for vendor users)
 * @param {string} divisionId  – The user's division ID
 * @param {string} storeGrp    – The store group
 * @returns {Promise<Array<{divisionId: string, customerId: string, custDiv: string}>>}
 *          List of location objects
 */
export async function GetDivisionByFactoryCode(factoryCode, userId, userType, divisionId, storeGrp) {
  try {
    const response = await fetch(
      `${VIPSDataServiceURL}/User/GetDivisionByFactoryCode?factoryCode=${encodeURIComponent(factoryCode)}` +
        `&userId=${encodeURIComponent(userId)}` +
        `&userType=${encodeURIComponent(userType)}` +
        `&divisionId=${encodeURIComponent(divisionId)}` +
        `&storeGroup=${encodeURIComponent(storeGrp)}`,
      requestOptions
    );
    const data = await response.json();
    return typeof data === 'string' ? JSON.parse(data) : data;
  } catch (err) {
    console.error("GetDivisionByFactoryCode failed:", err);
    return [];
  }
}
